var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAstr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.648 139.821C294.026 57.1731 222.47 -5.27009 139.821 0.351692C98.6489 3.1521 62.4983 22.3218 37.2713 51.0674L37.2715 51.0673L37.2011 51.0165C37.0311 51.2517 36.8723 51.4837 36.7035 51.7188C11.645 80.6047 -2.44854 119.013 0.351528 160.179C0.618351 164.102 1.08009 167.962 1.63804 171.789C1.63821 171.79 1.63821 171.79 1.63838 171.791C1.66351 171.964 1.68915 172.136 1.71345 172.309C2.09063 174.834 2.52857 177.336 3.02826 179.815C3.02859 179.816 3.02876 179.818 3.02909 179.819C3.03825 179.864 3.0469 179.909 3.05572 179.954C3.51064 182.199 4.01599 184.423 4.56894 186.629L4.56994 186.633C4.57044 186.635 4.57094 186.637 4.57128 186.638C21.8945 255.723 86.6221 304.652 160.179 299.648C242.827 294.027 305.27 222.469 299.648 139.821V139.821ZM266.998 142.042C267.69 152.217 267.05 162.18 265.238 171.765C265.215 171.71 265.198 171.652 265.175 171.598V171.597C254.301 145.016 232.79 125.826 213.873 115.225C217.702 70.1849 202.422 51.2099 185.128 48.1225C184.658 48.032 184.185 47.9548 183.704 47.8952C169.979 46.1348 157.427 55.8365 155.669 69.5612C153.908 83.2866 163.61 95.8387 177.335 97.5997C178.532 97.7512 179.716 97.7933 180.889 97.7748C180.965 99.2952 181.013 100.91 181.026 102.599C165.036 98.6366 150.088 97.861 136.46 99.0863C131.364 99.426 126.264 100.068 121.192 101.016C122.893 85.8072 128.599 68.7324 139.671 56.2368C150.374 44.1576 166.287 37.2342 183.646 39.0109C186.937 39.3476 190.448 40.1556 193.609 41.2172C193.754 41.266 193.909 41.3073 194.052 41.3572C194.054 41.3544 194.057 41.3506 194.059 41.3477C234.267 57.7274 263.858 95.8868 266.998 142.042ZM162.449 164.953C162.438 164.969 162.427 164.985 162.416 165.002C158.837 170.164 154.58 175.254 149.583 180.177C142.093 172.207 136.075 163.624 131.51 154.745C131.276 154.269 131.026 153.817 130.798 153.333C130.789 153.316 130.781 153.298 130.772 153.28C128.09 147.597 125.81 141.363 124.045 134.572C134.704 132.064 145.157 131.142 155.139 131.628C155.668 131.663 156.185 131.673 156.718 131.717C156.737 131.718 156.757 131.72 156.777 131.721C163.029 132.239 169.557 133.379 176.31 135.241C173.153 145.721 168.726 155.231 163.316 163.63C163.021 164.071 162.754 164.513 162.449 164.953H162.449ZM111.194 39.3593C111.166 39.3954 111.135 39.4295 111.107 39.4657L111.107 39.4658C93.5329 62.1624 87.6658 90.3693 87.9371 112.048C47.0196 131.252 38.2272 153.972 44.2004 170.492C44.3569 170.944 44.5268 171.393 44.7154 171.839C50.0537 184.606 64.7316 190.625 77.4965 185.285C90.2633 179.947 96.2827 165.269 90.9458 152.503C90.4782 151.39 89.9226 150.343 89.3202 149.337C90.6134 148.501 92.0021 147.643 93.4767 146.777C98.0402 162.609 104.791 176.001 112.668 187.192C115.505 191.428 118.604 195.515 121.953 199.426C107.93 205.56 90.2861 209.158 73.9251 205.817C58.1124 202.587 44.1603 192.268 37.0195 176.346C35.6659 173.328 34.6104 169.884 33.9489 166.616C33.5419 163.76 33.2009 160.882 33.0021 157.958C29.3472 104.227 62.6827 56.3923 111.194 39.3593V39.3593ZM157.958 266.998C126.051 269.168 96.225 258.285 73.6832 238.94C102.126 242.811 129.487 233.788 148.126 222.713C185.232 248.568 209.313 244.825 220.636 231.389C220.95 231.027 221.253 230.656 221.545 230.269C229.933 219.263 227.807 203.542 216.8 195.157C205.793 186.769 190.072 188.896 181.685 199.901C180.955 200.862 180.326 201.866 179.756 202.891C178.395 202.194 176.966 201.425 175.489 200.587C186.929 188.713 195.08 176.148 200.837 163.724C203.091 159.141 205.085 154.403 206.801 149.536C219.131 158.614 231.08 172.101 236.369 187.949C241.478 203.258 239.518 220.501 229.3 234.646C227.363 237.327 224.907 239.964 222.407 242.171C222.371 242.203 222.335 242.237 222.3 242.27C204.423 256.32 182.304 265.342 157.958 266.998H157.958Z",
    fill: "url(#paint0_linear_102_141)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M185.128 48.1226C184.658 48.032 184.185 47.9548 183.704 47.8952C181.276 47.5838 178.888 47.648 176.586 48.013C190.936 55.8193 201.398 77.5698 195.898 120.474C194.076 134.684 189.85 148.206 183.749 160.615C178.804 171.284 172.078 182.055 163.035 192.406C167.378 195.663 171.612 198.389 175.489 200.587C186.929 188.713 195.08 176.148 200.837 163.724C206.939 151.316 211.164 137.793 212.986 123.584C219.535 72.4989 203.457 51.3947 185.128 48.1226V48.1226Z",
    fill: "url(#paint1_radial_102_141)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.898 120.474C201.398 77.5698 190.936 55.8193 176.586 48.013C176.026 48.1019 175.476 48.2213 174.927 48.3473C188.976 56.4229 199.084 78.1529 193.658 120.474C191.836 134.684 187.611 148.206 181.509 160.615C176.729 170.931 170.264 181.339 161.669 191.374C162.127 191.728 162.581 192.065 163.035 192.406C172.078 182.055 178.805 171.284 183.749 160.615C189.85 148.206 194.076 134.684 195.898 120.474V120.474Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M141.356 217.784C140.008 216.757 138.71 215.681 137.412 214.606C116.236 223.441 86.8805 228.98 57.7321 222.216C62.5053 228.3 67.8321 233.918 73.6832 238.94C102.126 242.811 129.487 233.788 148.126 222.714C145.914 221.172 143.662 219.541 141.356 217.784V217.784Z",
    fill: "url(#paint2_radial_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    d: "M137.412 214.606C136.764 214.068 136.111 213.536 135.475 212.987C114.138 221.513 84.6492 226.61 55.5662 219.362C56.2748 220.324 56.9953 221.277 57.7321 222.216C86.8805 228.98 116.236 223.441 137.412 214.606V214.606Z",
    fill: "url(#paint3_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M44.2072 170.517C44.3637 170.969 44.5336 171.417 44.7222 171.863C45.6669 174.123 46.9163 176.158 48.3833 177.969C47.969 161.639 61.5745 141.703 101.481 125.015C114.698 119.487 128.521 116.385 142.318 115.465C154.03 114.412 166.722 114.853 180.207 117.508C180.856 112.119 181.1 107.089 181.065 102.632C165.062 98.6619 150.104 97.8852 136.467 99.1113C122.67 100.031 108.846 103.133 95.6293 108.66C48.1144 128.531 37.8764 153.007 44.2072 170.517V170.517Z",
    fill: "url(#paint4_radial_102_141)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.481 125.015C61.5745 141.703 47.969 161.639 48.3833 177.969C48.7404 178.41 49.1187 178.826 49.5022 179.238C49.4718 163.035 63.2365 143.416 102.6 126.954C115.817 121.427 129.641 118.325 143.438 117.405C154.762 116.387 167.009 116.781 179.996 119.207C180.074 118.634 180.139 118.072 180.207 117.508C166.722 114.853 154.03 114.412 142.318 115.465C128.521 116.385 114.698 119.487 101.481 125.015V125.015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M213.024 123.594C212.809 125.275 212.526 126.937 212.244 128.599C230.483 142.52 249.958 165.173 258.674 193.798C261.557 186.623 263.759 179.2 265.182 171.622C254.313 145.055 232.819 125.87 213.908 115.266C213.68 117.953 213.393 120.719 213.024 123.594Z",
    fill: "url(#paint5_radial_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M212.244 128.599C212.103 129.429 211.968 130.261 211.81 131.086C229.863 145.3 249.022 168.29 257.286 197.101C257.765 196.006 258.23 194.906 258.674 193.798C249.958 165.173 230.483 142.52 212.244 128.599V128.599Z",
    fill: "url(#paint6_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M220.653 231.355C220.967 230.993 221.27 230.622 221.562 230.235C223.046 228.288 224.184 226.188 225.019 224.012C211.084 232.536 187.017 230.721 152.611 204.505C141.215 195.823 131.617 185.402 123.922 173.914C117.154 164.297 111.19 153.086 106.746 140.08C101.755 142.212 97.2766 144.516 93.4343 146.775C97.9978 162.618 104.804 175.961 112.685 187.158C120.38 198.647 129.978 209.067 141.373 217.75C182.339 248.964 208.655 245.592 220.653 231.355V231.355Z",
    fill: "url(#paint7_radial_102_141)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.611 204.505C187.017 230.721 211.084 232.536 225.019 224.012C225.222 223.482 225.394 222.946 225.559 222.408C211.541 230.536 187.669 228.425 153.73 202.566C142.335 193.883 132.737 183.463 125.042 171.975C118.498 162.677 112.717 151.873 108.323 139.413C107.789 139.632 107.269 139.857 106.746 140.08C111.19 153.086 117.154 164.297 123.922 173.914C131.617 185.402 141.215 195.823 152.611 204.505H152.611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    d: "M95.6083 108.616C97.1724 107.962 98.7528 107.376 100.333 106.79C103.269 84.0332 113.15 55.8407 133.582 33.9796C125.927 35.0713 118.398 36.8754 111.123 39.4319C93.5496 62.1286 87.6828 90.3356 87.9542 112.014C90.3957 110.869 92.9343 109.734 95.6083 108.616V108.616Z",
    fill: "url(#paint8_radial_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M100.333 106.79C101.123 106.497 101.91 106.198 102.704 105.921C105.987 83.1801 116.318 55.0933 137.137 33.5308C135.949 33.6633 134.764 33.8112 133.582 33.9796C113.15 55.8407 103.269 84.0332 100.333 106.79V106.79Z",
    fill: "url(#paint9_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M139.821 0.351699C98.6489 3.15211 62.4983 22.3218 37.2713 51.0674C37.0807 51.2847 36.8913 51.5024 36.702 51.7208L36.7035 51.7188C41.6149 56.5905 57.666 66.1966 64.1715 70.2024C76.9448 56.4655 93.0025 45.7467 111.194 39.3593C112.465 37.7222 113.782 36.107 115.177 34.5327C132.12 15.4132 155.259 5.30751 182.096 5.30751C185.083 5.30751 191.167 5.78298 191.298 5.79264C175.028 1.11832 157.688 -0.863634 139.821 0.351699Z",
    fill: "url(#paint10_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M157.958 266.998C126.051 269.168 96.225 258.285 73.6832 238.94H73.6831L73.6829 238.94C71.5848 238.654 69.482 238.311 67.3757 237.881C42.346 232.767 22.025 217.782 8.60627 194.54C7.11268 191.953 5.77623 189.317 4.57178 186.64C21.8955 255.724 86.6228 304.652 160.179 299.648C160.505 292.074 158.272 274.498 157.958 266.998L157.958 266.998Z",
    fill: "url(#paint11_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M299.648 139.821C295.04 139.349 272.532 141.126 266.998 142.042C267.69 152.217 267.05 162.18 265.238 171.765C266.015 173.671 266.751 175.607 267.413 177.589C275.499 201.822 272.681 226.914 259.263 250.156C257.797 252.694 256.214 255.126 254.534 257.467C254.502 257.511 254.465 257.562 254.438 257.599C254.437 257.601 254.507 257.541 254.547 257.505C285.013 227.864 302.759 185.552 299.648 139.821V139.821Z",
    fill: "url(#paint12_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M183.646 39.0109C186.937 39.3477 190.448 40.1556 193.609 41.2173C193.754 41.266 193.909 41.3073 194.052 41.3572C194.054 41.3544 194.057 41.3506 194.059 41.3478C206.999 46.619 218.829 54.1563 229.042 63.4795C229.064 63.4978 229.086 63.5128 229.108 63.5311C234.03 57.904 243.507 51.7208 243.507 51.7208C243.507 51.7208 228.995 36.8765 206.801 32.2697C191.263 29.0447 156.217 25.9186 134.114 63.5311C134.114 63.5311 134.202 63.4482 134.331 63.3289C135.966 60.8575 137.705 58.4555 139.671 56.2368C150.374 44.1576 166.287 37.2342 183.646 39.0109V39.0109Z",
    fill: "url(#paint13_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M229.296 234.633C227.359 237.314 224.904 239.951 222.404 242.158C222.289 242.259 222.176 242.372 222.061 242.472C222.063 242.475 222.064 242.48 222.066 242.483C211.031 251.053 198.588 257.53 185.408 261.713C185.381 261.723 185.357 261.734 185.33 261.744C187.742 268.82 188.359 280.119 188.359 280.119C188.359 280.119 208.47 274.974 223.557 258.056C234.119 246.212 254.349 217.425 232.827 179.477C232.827 179.477 232.855 179.595 232.894 179.766C234.216 182.418 235.427 185.124 236.366 187.936C241.475 203.245 239.515 220.488 229.296 234.633V234.633Z",
    fill: "url(#paint14_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M37.0719 176.391C35.7181 173.372 34.6621 169.927 34.0009 166.659C33.9705 166.509 33.9291 166.354 33.9005 166.205C33.8971 166.205 33.8923 166.204 33.8888 166.204C31.9841 152.362 32.5965 138.348 35.5643 124.842C35.5691 124.814 35.5711 124.787 35.5759 124.759C28.2417 123.31 18.1483 118.194 18.1483 118.194C18.1483 118.194 12.5487 138.184 19.6565 159.708C24.6324 174.777 39.448 206.691 83.0729 207.026C83.0729 207.026 82.9571 206.991 82.7891 206.939C79.8313 206.759 76.8819 206.454 73.9775 205.861C58.1648 202.631 44.2126 192.312 37.0719 176.391H37.0719Z",
    fill: "url(#paint15_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M177.335 97.5997C178.532 97.7512 179.716 97.7933 180.889 97.7748C180.889 97.7748 180.106 82.1893 178.192 74.1929C176.278 66.1965 173.456 60.9012 170.355 57.904C168.134 55.7569 161.122 53.0829 155.669 69.5612C153.908 83.2866 163.61 95.8387 177.335 97.5997Z",
    fill: "url(#paint16_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M90.9527 152.528C90.4851 151.415 89.9295 150.368 89.327 149.362C89.327 149.362 76.2213 157.833 70.2531 163.489C64.2849 169.144 61.1103 174.236 60.065 178.42C59.3161 181.417 60.5064 188.827 77.5035 185.31C90.2702 179.972 96.2897 165.294 90.9527 152.528Z",
    fill: "url(#paint17_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M181.705 199.86C180.975 200.822 180.347 201.826 179.776 202.851C179.776 202.851 193.666 209.965 201.548 212.306C209.429 214.647 215.427 214.85 219.573 213.664C222.543 212.814 228.365 208.078 216.82 195.117C205.814 186.729 190.093 188.855 181.705 199.86V199.86Z",
    fill: "url(#paint18_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M176.31 135.241C173.153 145.721 168.726 155.231 163.316 163.63C163.021 164.071 162.754 164.513 162.449 164.953C162.438 164.969 162.427 164.985 162.416 165.002C158.837 170.164 154.58 175.254 149.583 180.177C153.017 183.83 156.731 187.367 160.809 190.723C165.93 194.765 170.95 198.014 175.489 200.587C186.929 188.713 195.08 176.148 200.837 163.724C203.091 159.141 205.085 154.403 206.801 149.536C201.523 145.651 196.177 142.56 191.251 140.46C186.157 138.288 181.177 136.583 176.31 135.241V135.241Z",
    fill: "url(#paint19_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M73.6832 238.94C102.126 242.811 129.487 233.788 148.126 222.714C145.914 221.172 143.662 219.541 141.356 217.784C134.162 212.302 127.688 206.125 121.953 199.426C107.93 205.56 90.2861 209.158 73.9251 205.817C58.1124 202.587 44.1603 192.268 37.0195 176.346C35.6659 173.328 34.6104 169.884 33.9489 166.616C38.0813 195.612 52.7133 220.943 73.6832 238.94V238.94Z",
    fill: "url(#paint20_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M149.583 180.177C142.093 172.207 136.076 163.624 131.51 154.745C131.276 154.269 131.026 153.817 130.798 153.333C130.789 153.316 130.781 153.298 130.772 153.28C128.09 147.597 125.81 141.363 124.045 134.572C119.175 135.718 114.266 137.163 109.332 139.012C103.284 141.421 97.9691 144.138 93.4767 146.777C98.0402 162.609 104.791 176.001 112.668 187.192C115.505 191.428 118.604 195.515 121.953 199.426C127.966 196.797 133.324 193.708 137.611 190.488C142.032 187.168 145.993 183.714 149.583 180.177V180.177Z",
    fill: "url(#paint21_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M111.107 39.4658C93.533 62.1624 87.6658 90.3693 87.9372 112.048C90.3878 110.898 92.9376 109.758 95.6226 108.635C103.957 105.15 112.534 102.634 121.192 101.016C122.893 85.8072 128.599 68.7325 139.671 56.2368C150.374 44.1577 166.287 37.2342 183.646 39.0109C186.937 39.3477 190.448 40.1556 193.609 41.2173C193.755 41.266 193.909 41.3073 194.052 41.3572C194.054 41.3544 194.057 41.3506 194.059 41.3478C178.067 34.8328 160.4 31.7536 142.042 33.0023C131.26 33.7357 120.929 35.9415 111.194 39.3593C111.167 39.3954 111.135 39.4295 111.107 39.4657L111.107 39.4658V39.4658Z",
    fill: "url(#paint22_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M265.175 171.597C254.301 145.016 232.79 125.826 213.873 115.225C213.644 117.921 213.356 120.698 212.986 123.584C211.837 132.544 209.729 141.23 206.801 149.536C219.131 158.614 231.08 172.101 236.369 187.949C241.478 203.258 239.518 220.501 229.3 234.646C227.363 237.327 224.907 239.964 222.407 242.171C222.371 242.203 222.335 242.237 222.299 242.27C244.322 224.962 259.897 200.016 265.238 171.765C265.215 171.71 265.198 171.652 265.175 171.598V171.597V171.597Z",
    fill: "url(#paint23_linear_102_141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M121.103 119.055C121.768 124.541 122.777 129.696 124.045 134.572C134.704 132.064 145.157 131.142 155.139 131.628C155.668 131.663 156.185 131.673 156.718 131.717C156.737 131.718 156.757 131.72 156.777 131.721C163.029 132.239 169.557 133.379 176.31 135.241C177.755 130.447 178.959 125.469 179.825 120.268C180.766 113.802 181.068 107.823 181.026 102.599C165.036 98.6366 150.088 97.8611 136.46 99.0864C131.364 99.4261 126.264 100.068 121.192 101.016C120.462 107.541 120.457 113.729 121.103 119.055V119.055Z",
    fill: "url(#paint24_linear_102_141)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_141",
    x1: 47.6338,
    y1: 252.373,
    x2: 238.908,
    y2: 61.0981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001139,
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207149,
    stopColor: "#703AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456011,
    stopColor: "#0070EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768132,
    stopColor: "#0297FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AE2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.756 119.637) scale(57.0329 57.0329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.454 225.44) scale(33.1822 33.1822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_141",
    x1: 58.6576,
    y1: 219.827,
    x2: 90.6431,
    y2: 219.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.326 128.153) rotate(-120) scale(57.0329 57.0329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.106 148.259) rotate(-120) scale(33.1822 33.1822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_141",
    x1: 256.143,
    y1: 194.191,
    x2: 239.766,
    y2: 166.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.213 199.566) rotate(120) scale(57.0329 57.0329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_102_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.429 76.2943) rotate(120) scale(33.1822 33.1822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_102_141",
    x1: 135.188,
    y1: 35.9754,
    x2: 119.58,
    y2: 63.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_102_141",
    x1: 142.142,
    y1: 21.7814,
    x2: 93.2748,
    y2: 35.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_102_141",
    x1: 49.7928,
    y1: 208.156,
    x2: 90.6632,
    y2: 250.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_102_141",
    x1: 269.146,
    y1: 201.728,
    x2: 283.361,
    y2: 158.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_102_141",
    x1: 164.408,
    y1: 46.5082,
    x2: 229.924,
    y2: 61.5096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_102_141",
    x1: 232.422,
    y1: 214.224,
    x2: 186.673,
    y2: 263.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_102_141",
    x1: 53.1836,
    y1: 189.302,
    x2: 33.4169,
    y2: 125.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_102_141",
    x1: 178.731,
    y1: 70.6726,
    x2: 158,
    y2: 91.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_102_141",
    x1: 66.9347,
    y1: 164.782,
    x2: 95.2543,
    y2: 172.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_102_141",
    x1: 204.327,
    y1: 214.534,
    x2: 196.738,
    y2: 186.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_102_141",
    x1: 161.22,
    y1: 189.352,
    x2: 173.659,
    y2: 172.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_102_141",
    x1: 118.389,
    y1: 181.915,
    x2: 93.5116,
    y2: 193.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_102_141",
    x1: 109.362,
    y1: 140.504,
    x2: 117.062,
    y2: 156.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_102_141",
    x1: 145.183,
    y1: 91.112,
    x2: 139.852,
    y2: 72.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_102_141",
    x1: 202.637,
    y1: 175.182,
    x2: 218.038,
    y2: 178.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_102_141",
    x1: 178.468,
    y1: 123.158,
    x2: 158.922,
    y2: 119.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstr);
export default __webpack_public_path__ + "static/media/astr.621149812a3e37eb3c772697b3298e62.svg";
export { ForwardRef as ReactComponent };